import { MockedProvider } from "@apollo/client/testing/react";
import React, { useMemo } from "react";
import { MockedAuthManager } from "../../contexts/AuthManager";
import { buildActivityTodo, buildUser } from "../factories";
import UserTodosScreen from "../../screens/user/UserTodos";
import { GET_ACTIVITY_TODO_FEED } from "../../graphql/activity";
import { ProfileType } from "../../__generated__/graphql";
import type { Meta, StoryObj } from "@storybook/react";
import { MockedProfileSwitcherManager } from "../../contexts/ProfileSwitcherManager";
import { StoryStackNavigatorContainer } from "../display-helpers";
import { createNativeStackNavigator } from "@react-navigation/native-stack";

const Stack = createNativeStackNavigator<{
    TodoList: { filters?: string };
}>();

const StoryComponent = ({ profileType }: { profileType: ProfileType }) => {
    const mocks = [
        {
            request: {
                query: GET_ACTIVITY_TODO_FEED,
                variables: () => true,
            },
            result: () => {
                return {
                    data: {
                        getActivityTodoFeed: [
                            buildActivityTodo({ id: "todo-1" }),
                            buildActivityTodo({ id: "todo-2" }),
                            buildActivityTodo({ id: "todo-3" }),
                            buildActivityTodo({ id: "todo-4" }),
                            buildActivityTodo({ id: "todo-5" }),
                            buildActivityTodo({ id: "todo-6" }),
                            buildActivityTodo({ id: "todo-7" }),
                            buildActivityTodo({ id: "todo-8" }),
                            buildActivityTodo({ id: "todo-9" }),
                            buildActivityTodo({ id: "todo-10" }),
                            buildActivityTodo({ id: "todo-11" }),
                            buildActivityTodo({ id: "todo-12" }),
                            buildActivityTodo({ id: "todo-13" }),
                            buildActivityTodo({ id: "todo-14" }),
                            buildActivityTodo({ id: "todo-15" }),
                            buildActivityTodo({
                                id: "todo-16",
                                badgeUrl:
                                    "https://yoolk.ninja/wp-content/uploads/2022/04/OnePiece-Monkey-D-Luffy.png",
                            }),
                        ],
                    },
                };
            },
        },
    ];
    const user = useMemo(() => buildUser(), []);

    return (
        <MockedAuthManager user={user}>
            <MockedProfileSwitcherManager profileType={profileType}>
                <MockedProvider mocks={mocks}>
                    <StoryStackNavigatorContainer>
                        <Stack.Navigator initialRouteName="TodoList">
                            <Stack.Screen
                                name="TodoList"
                                component={UserTodosScreen}
                                options={{ headerShown: false }}
                            />
                        </Stack.Navigator>
                    </StoryStackNavigatorContainer>
                </MockedProvider>
            </MockedProfileSwitcherManager>
        </MockedAuthManager>
    );
};

const meta = {
    title: "Screens/Todos",
    component: StoryComponent,
    argTypes: {
        profileType: {
            options: [ProfileType.Worker, ProfileType.Client],
            control: { type: "radio" },
        },
    },
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Worker: Story = {
    args: {
        profileType: ProfileType.Worker,
    },
};

export const Client: Story = {
    args: {
        profileType: ProfileType.Client,
    },
};
